import { getIn } from 'formik'
import { useContext } from 'react'
import { Card, CardBody, Row } from 'reactstrap'
import { PROPERTY_STATUS, REAL_ESTATE_SERVICE } from '../../common/constants'
import { propertyTransactionsFields, realEstateGeneralFields } from '../../common/forms/generalRealEstate/fields'
import { usePropertyTransactionsFormSelectOptions } from '../../pages/Properties/hooks'
import AppPermissionsSwitcher from '../AppPermissionsSwitcher/AppPermissionsSwitcher'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import RecursiveForm from '../RecursiveForm'
import PropertyFormTransactionsContext from './PropertyFormTransactionsContext'

const PropertyFormTransactionsTab = (props) => {
    const { children, tabs, activeTab, handleTabChange, formik, inputs, subform, module, property } = props

    const { selectOptions, isPending: selectOptionsLoading } = usePropertyTransactionsFormSelectOptions(
        property?.owner,
        property?.propertyTransaction?.contact
    )

    return (
        <PropertyFormTransactionsContext.Provider
            value={{
                tabs,
                activeTab,
                handleTabChange,
                formik,
                inputs,
                subform,
                module,
                selectOptions,
                selectOptionsLoading,
            }}
        >
            <Row>{children}</Row>
        </PropertyFormTransactionsContext.Provider>
    )
}

export const PropertyFormTransactionsTabSide = () => {
    const { inputs, subform, formik, module, selectOptions, selectOptionsLoading } = useContext(PropertyFormTransactionsContext)

    const propertyServiceId = getIn(formik?.values?.general, realEstateGeneralFields.PROPERTY_SERVICE_ID)
    const propertyStatusId = getIn(formik?.values?.transactions, propertyTransactionsFields.PROPERTY_STATUS_ID)

    const propertyStatusOptions = selectOptions?.property_status_id || []
    let filteredPropertyStatuses = propertyStatusOptions

    const filterPropertyStatuses = (allowedStatuses) => {
        return propertyStatusOptions.filter((item) => allowedStatuses.includes(Number(item.value)))
    }

    const activePropertySellingStatuses = [
        PROPERTY_STATUS.ACTIVE_OFFER,
        PROPERTY_STATUS.RESERVED,
        PROPERTY_STATUS.SOLD,
        PROPERTY_STATUS.SOLD_OWNER,
        PROPERTY_STATUS.SOLD_OWNER_ARCHIVED,
        PROPERTY_STATUS.WITHDRAWN_OFFER_ARCHIVED,
        PROPERTY_STATUS.SOLD_ARCHIVED,
        PROPERTY_STATUS.FOR_AUTHORIZATION,
        PROPERTY_STATUS.ANOTHER_AGENCY_AD,
    ]

    const activePropertyRentingStatuses = [
        PROPERTY_STATUS.ACTIVE_OFFER,
        PROPERTY_STATUS.RESERVED,
        PROPERTY_STATUS.RENTED,
        PROPERTY_STATUS.RENTED_OWNER,
        PROPERTY_STATUS.RENTED_OWNER_ARCHIVED,
        PROPERTY_STATUS.WITHDRAWN_OFFER_ARCHIVED,
        PROPERTY_STATUS.RENTED_ARCHIVED,
        PROPERTY_STATUS.FOR_AUTHORIZATION,
        PROPERTY_STATUS.ANOTHER_AGENCY_AD,
    ]

    const finalizedPropertySellingStatuses = [PROPERTY_STATUS.SOLD, PROPERTY_STATUS.SOLD_ARCHIVED]
    const finalizedPropertyRentingStatuses = [PROPERTY_STATUS.RENTED, PROPERTY_STATUS.RENTED_ARCHIVED]

    if (propertyServiceId === REAL_ESTATE_SERVICE.sale) {
        const allowedStatuses = finalizedPropertySellingStatuses.includes(Number(propertyStatusId))
            ? finalizedPropertySellingStatuses
            : activePropertySellingStatuses

        filteredPropertyStatuses = filterPropertyStatuses(allowedStatuses)
    }

    if (propertyServiceId === REAL_ESTATE_SERVICE.lease) {
        const allowedStatuses = finalizedPropertyRentingStatuses.includes(Number(propertyStatusId))
            ? finalizedPropertyRentingStatuses
            : activePropertyRentingStatuses

        filteredPropertyStatuses = filterPropertyStatuses(allowedStatuses)
    }

    const filteredSelectOptions = {
        ...selectOptions,
        property_status_id: filteredPropertyStatuses,
    }

    return (
        <FormSideContainer>
            <Card>
                <CardBody>
                    <AppPermissionsSwitcher permission="PropertyStatus" module={module} selectOptions={filteredSelectOptions}>
                        {({ newSelectOptions }) => (
                            <RecursiveForm
                                inputs={inputs?.sideForm}
                                subform={subform}
                                formik={formik}
                                selectOptions={newSelectOptions}
                                selectOptionsLoading={selectOptionsLoading}
                            />
                        )}
                    </AppPermissionsSwitcher>
                </CardBody>
            </Card>
        </FormSideContainer>
    )
}

export const PropertyFormTransactionsTabMain = () => {
    const { inputs, formik, subform, tabs, activeTab, handleTabChange, module, selectOptions, selectOptionsLoading } =
        useContext(PropertyFormTransactionsContext)

    return (
        <FormMainContainer ainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange}>
            <AppPermissionsSwitcher permission="EditData" data={inputs?.mainForm} module={module}>
                {({ newData }) => (
                    <RecursiveForm
                        inputs={newData}
                        subform={subform}
                        formik={formik}
                        selectOptions={selectOptions}
                        selectOptionsLoading={selectOptionsLoading}
                    />
                )}
            </AppPermissionsSwitcher>
        </FormMainContainer>
    )
}

export default PropertyFormTransactionsTab
